import { render, staticRenderFns } from "./HistorialSection.vue?vue&type=template&id=19e3d56e&scoped=true&"
import script from "./HistorialSection.vue?vue&type=script&lang=js&"
export * from "./HistorialSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e3d56e",
  null
  
)

export default component.exports